import React, { createContext, useContext, useEffect, useState } from "react";

const CompareContext = createContext(null);

export function CompareProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("vanturis_compare") || "[]"); }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("vanturis_compare", JSON.stringify(items));
  }, [items]);

  const add = (listing) => {
    setItems((prev) => {
      if (prev.find((l) => l.id === listing.id)) return prev;
      if (prev.length >= 3) return [...prev.slice(1), listing];
      return [...prev, listing];
    });
  };
  const remove = (id) => setItems((p) => p.filter((l) => l.id !== id));
  const clear = () => setItems([]);
  const has = (id) => !!items.find((l) => l.id === id);

  return (
    <CompareContext.Provider value={{ items, add, remove, clear, has }}>
      {children}
    </CompareContext.Provider>
  );
}

export function useCompare() { return useContext(CompareContext); }
